<template>
  <!-- 搜索 -->
  <div ref="topDom" class="header-bar">
    <div class="bar-lef"></div>
    <div class="bar-rig">
      <div class="rig-one">
        <a-input-search v-model:value="searchForm.keyword" :loading="searchLoading" allowClear placeholder="房间名称|苏安码|门店" @search="getTableList"> </a-input-search>
      </div>
      <div class="rig-group">
        <div class="group-one">
          <a-select v-model:value="searchForm.status" allowClear placeholder="上报状态" @change="getTableList()">
            <a-select-option :value="0">待上报</a-select-option>
            <a-select-option :value="1">上报中</a-select-option>
            <a-select-option :value="2">上报成功</a-select-option>
            <a-select-option :value="3">上报失败</a-select-option>
          </a-select>
        </div>
      </div>
      <div class="rig-group">
        <div class="group-one">
          <a-select v-model:value="searchForm.AZZT" allowClear placeholder="安装状态" @change="getTableList()">
            <a-select-option :value="0">未安装</a-select-option>
            <a-select-option :value="1">已安装</a-select-option>
            <a-select-option :value="2">已拆除</a-select-option>
          </a-select>
        </div>
      </div>
      <div class="rig-one-no-shadow">
        <a-button type="link" @click="handleReset">重置筛选</a-button>
      </div>
    </div>
  </div>

  <!-- 表格 -->
  <a-table
    :columns="columns"
    :dataSource="dataSource"
    :loading="searchLoading"
    :pagination="false"
    :scroll="{
      x: columns.length > 8 ? columns.length * 130 : 0,
      y: tableHeight,
    }"
    class="table"
    size="small"
  >
    <template #bodyCell="{ column, record }">
      <template v-if="column.key == 'status_text'">
        <div v-if="record.status == 3" class="f-c-red">
          {{ record.status_text }}
        </div>
        <div v-else-if="record.status == 2" class="f-c-green">{{ record.status_text }}</div>
        <div v-else>{{ record.status_text }}</div>
      </template>
      <template v-if="column.key == 'operate'">
        <a-button type="link" @click="openDetails(record, 2)">编辑</a-button>
        <a-button type="link" @click="openDetails(record, 1)">查看</a-button>
        <a-button type="link" @click="operSyn(record)">同步</a-button>
      </template>
    </template>
  </a-table>

  <!-- 分页 -->
  <MyPagination :pageTotal="pageTotal" @onShowSizeChange="onShowSizeChange" @pageChange="pageChange" />

  <!-- 弹窗 -->
  <a-modal v-model:visible="visibleAdd" :title="formTitle" :width="'80%'" class="modal" @ok="confirmFun">
    <a-form ref="formRef" :label-col="{ span: 12 }" :model="addForm" :rules="rules">
      <a-row :gutter="24" class="row-box">
        <a-col :span="12">
          <a-form-item v-if="addForm.id" class="f-item" label="记录ID" name="id">
            <div v-if="isLook">{{ addForm.id }}</div>
            <a-input v-else v-model:value="addForm.id" disabled />
          </a-form-item>
          <a-form-item class="f-item" label="房源登记编号" name="FYDJBH">
            <div v-if="isLook">{{ addForm.FYDJBH }}</div>
            <a-input v-else v-model:value="addForm.FYDJBH" disabled />
          </a-form-item>
          <a-form-item class="f-item" label="苏安码" name="FYTYBM">
            <div v-if="isLook">{{ addForm.FYTYBM }}</div>
            <a-input v-else v-model:value="addForm.FYTYBM" disabled />
          </a-form-item>
          <a-form-item class="f-item" label="经营者登记编号" name="JYZDJBH">
            <div v-if="isLook">{{ addForm.JYZDJBH }}</div>
            <a-input v-else v-model:value="addForm.JYZDJBH" disabled />
          </a-form-item>
          <a-form-item class="f-item" label="所属省编码" name="FYSS1">
            <div v-if="isLook">{{ addForm.FYSS1 }}</div>
            <a-input v-else v-model:value="addForm.FYSS1" disabled />
          </a-form-item>
          <a-form-item class="f-item" label="所属市编码" name="FYSS2">
            <div v-if="isLook">{{ addForm.FYSS2 }}</div>
            <a-input v-else v-model:value="addForm.FYSS2" disabled />
          </a-form-item>
          <a-form-item class="f-item" label="所属区县编码" name="FYSSQH">
            <div v-if="isLook">{{ addForm.FYSSQH }}</div>
            <a-input v-else v-model:value="addForm.FYSSQH" disabled />
          </a-form-item>
          <a-form-item class="f-item" label="详细地址" name="FYXXDZ">
            <div v-if="isLook">{{ addForm.FYXXDZ }}</div>
            <a-input v-else v-model:value="addForm.FYXXDZ" disabled />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item class="f-item" label="经度" name="FYDWJD">
            <div v-if="isLook">{{ addForm.FYDWJD }}</div>
            <a-input v-else v-model:value="addForm.FYDWJD" disabled />
          </a-form-item>
          <a-form-item class="f-item" label="纬度" name="FYDWWD">
            <div v-if="isLook">{{ addForm.FYDWWD }}</div>
            <a-input v-else v-model:value="addForm.FYDWWD" disabled />
          </a-form-item>
          <a-form-item label="所属门店" name="store_id" style="margin-bottom: 10px !important">
            <div v-if="isLook">{{ addForm.sname }}</div>
            <a-select v-else v-model:value="addForm.sname" :allowClear="true" :disabled="canSelectStore" mode="default" placeholder="门店" style="width: 150px" @change="selectStore">
              <a-select-option v-for="item in searchList.store?.list" :key="item.id" :label="item.name" :value="item.id">{{ item.name }} </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item class="f-item" label="房源名称" name="FYFX">
            <div v-if="isLook">{{ addForm.FYFX }}</div>
            <a-input v-else v-model:value="addForm.FYFX" placeholder="请输入房源名称" />
          </a-form-item>
          <a-form-item label="房源数据类型" name="SFCZ" style="margin-bottom: 10px !important">
            <div v-if="isLook">{{ addForm.SFCZ_text }}</div>
            <a-select v-else ref="select" v-model:value="addForm.SFCZ" style="width: 100%">
              <a-select-option key="0" value="0">短租房</a-select-option>
              <a-select-option key="1" value="1">长租房</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="门锁品牌" name="MSPP" style="margin-bottom: 10px !important">
            <div v-if="isLook">{{ addForm.MSPP_text }}</div>
            <a-select v-else ref="select" v-model:value="addForm.MSPP" style="width: 100%">
              <a-select-option key="1" value="1">全民认证</a-select-option>
              <a-select-option key="2" value="2">永安行</a-select-option>
              <a-select-option key="3" value="3">警联锁</a-select-option>
              <a-select-option key="4" value="4">美团(云闪住)</a-select-option>
              <a-select-option key="5" value="5">途家(安伴智能)</a-select-option>
              <a-select-option key="6" value="6">艺龙(未来前台)</a-select-option>
              <a-select-option key="7" value="7">同程(惠想住)</a-select-option>
              <a-select-option key="8" value="8">小猪(中安旅)</a-select-option>
              <a-select-option key="9" value="9">苏安居</a-select-option>
              <a-select-option key="10" value="10">其他</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item class="f-item" label="门锁功能" name="MSGN">
            <div v-if="isLook">{{ addForm.MSGN }}</div>
            <a-checkbox-group v-model:value="selectOptions" :options="lockOptions" />
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
    <div class="f-c-red" style="text-align: left; margin: 15px">
      <div>注意事项</div>
      <div>1、苏安码请在公众号中绑定</div>
      <div>2、房间信息请在公众号中修改所在区域及详细地址等</div>
      <div>3、如果需要变更经营者(门店),请在公众号门店房源关联中变更，变更后，需要手动再次同步更新房源信息</div>
      <div>4、房源上报成功，才会上报房源的订单和入住登记信息等</div>
    </div>
  </a-modal>
</template>

<script>
import { createVNode, onMounted, reactive, toRefs, watch } from 'vue';
import { ChangZhouHouseDetail, ChangZhouHouseEdit, ChangZhouHouseList, ChangZhouHouseSyn, getSearchList } from '@/api/api';
import { ExclamationCircleOutlined } from '@ant-design/icons-vue';
import { message, Modal } from 'ant-design-vue';
import useUtils from '@/hooks/useUtils.js'; //工具库
import store from '@/store/pms/landlord/index'; //VUEX
import router from '@/router/index';

export default {
  components: {
    // LoadingOutlined,
    // PlusOutlined,
  },
  setup() {
    let { imgCut, countTable } = useUtils();

    // 搜索
    let search = reactive({
      topDom: '',
      searchForm: {
        keyword: '',
        status: [],
        AZZT: [],
        start: 0,
        limit: store.getters.getPageSize,
      },
      searchLoading: false,
      // 重置
      handleReset() {
        search.searchForm.keyword = '';
        search.searchForm.status = [];
        search.searchForm.AZZT = [];
        table.getTableList();
      },
    });

    // 表格
    let table = reactive({
      editId: [],
      tableHeight: '',
      dataSource: [],
      columns: [
        { title: 'ID', dataIndex: 'id', key: 'id', width: 80, isShow: true, align: 'center', ellipsis: true },
        {
          title: '门店ID',
          dataIndex: 'store_id',
          key: 'store_id',
          width: 80,
          isShow: true,
          align: 'center',
          ellipsis: true,
        },
        {
          title: '门店名称',
          dataIndex: 'store_name',
          key: 'store_name',
          width: 100,
          isShow: true,
          align: 'center',
          ellipsis: true,
        },
        { title: '房间ID', dataIndex: 'hid', key: 'hid', width: 80, isShow: true, align: 'center', ellipsis: true },
        {
          title: '房间名称',
          dataIndex: 'hname',
          key: 'hname',
          width: 150,
          isShow: true,
          align: 'center',
          ellipsis: true,
        },
        {
          title: '登记编号',
          dataIndex: 'FYDJBH',
          key: 'FYDJBH',
          width: 80,
          isShow: true,
          align: 'center',
          ellipsis: true,
        },
        {
          title: '苏安码',
          dataIndex: 'FYTYBM',
          key: 'FYTYBM',
          width: 200,
          isShow: true,
          align: 'center',
          ellipsis: true,
        },
        {
          title: '经营者编号',
          dataIndex: 'JYZDJBH',
          key: 'JYZDJBH',
          width: 80,
          isShow: true,
          align: 'center',
          ellipsis: true,
        },
        { title: '房源名称', dataIndex: 'FYFX', key: 'FYFX', width: 150, isShow: true, align: 'center', ellipsis: true },
        {
          title: '状态',
          dataIndex: 'status_text',
          key: 'status_text',
          width: 80,
          isShow: true,
          align: 'center',
          ellipsis: true,
        },
        { title: '备注', dataIndex: 'remark', key: 'remark', width: 200, isShow: true, align: 'center', ellipsis: true },
        {
          title: '最近上报时间',
          dataIndex: 'synTime_text',
          key: 'synTime_text',
          width: 150,
          isShow: true,
          align: 'center',
          ellipsis: true,
        },
        {
          title: '房源所属省',
          dataIndex: 'FYSS1',
          key: 'FYSS1',
          width: 80,
          isShow: true,
          align: 'center',
          ellipsis: true,
        },
        {
          title: '房源所属市',
          dataIndex: 'FYSS2',
          key: 'FYSS2',
          width: 80,
          isShow: true,
          align: 'center',
          ellipsis: true,
        },
        {
          title: '房源所属区',
          dataIndex: 'FYSSQH',
          key: 'FYSSQH',
          width: 80,
          isShow: true,
          align: 'center',
          ellipsis: true,
        },
        {
          title: '房源详细地址',
          dataIndex: 'FYXXDZ',
          key: 'FYXXDZ',
          width: 200,
          isShow: true,
          align: 'center',
          ellipsis: true,
        },
        {
          title: '房源经度',
          dataIndex: 'FYDWJD',
          key: 'FYDWJD',
          width: 80,
          isShow: true,
          align: 'center',
          ellipsis: true,
        },
        {
          title: '房源纬度',
          dataIndex: 'FYDWWD',
          key: 'FYDWWD',
          width: 80,
          isShow: true,
          align: 'center',
          ellipsis: true,
        },
        {
          title: '房源类型',
          dataIndex: 'SFCZ_text',
          key: 'SFCZ_text',
          width: 100,
          isShow: true,
          align: 'center',
          ellipsis: true,
        },
        {
          title: '门锁品牌',
          dataIndex: 'MSPP_text',
          key: 'MSPP_text',
          width: 80,
          isShow: true,
          align: 'center',
          ellipsis: true,
        },
        {
          title: '门锁功能',
          dataIndex: 'MSGN_text',
          key: 'MSGN_text',
          width: 200,
          isShow: true,
          align: 'center',
          ellipsis: true,
        },
        { title: '门锁MAC', dataIndex: 'MSMAC', key: 'MSMAC', width: 100, isShow: true, align: 'center', ellipsis: true },
        {
          title: '安装状态',
          dataIndex: 'AZZT_text',
          key: 'AZZT_text',
          width: 80,
          isShow: true,
          align: 'center',
          ellipsis: true,
        },
        {
          title: '安装时间',
          dataIndex: 'AZSJ_text',
          key: 'AZSJ_text',
          width: 150,
          isShow: true,
          align: 'center',
          ellipsis: true,
        },
        {
          title: '拆除时间',
          dataIndex: 'CCSJ_text',
          key: 'CCSJ_text',
          width: 150,
          isShow: true,
          align: 'center',
          ellipsis: true,
        },
        {
          title: '登记时间',
          dataIndex: 'DJSJ_text',
          key: 'DJSJ_text',
          width: 150,
          isShow: true,
          align: 'center',
          ellipsis: true,
        },
        {
          title: '创建时间',
          dataIndex: 'create_time',
          key: 'create_time',
          width: 150,
          isShow: true,
          align: 'center',
          ellipsis: true,
        },
        { title: '操作', dataIndex: 'operate', key: 'operate', width: 200, fixed: 'right', align: 'center' },
      ],
      companyLogo: JSON.parse(sessionStorage.getItem('companyInfo') || '{}').logo || '',
      getTableList() {
        search.searchLoading = true;
        ChangZhouHouseList({
          keyword: search.searchForm.keyword,
          AZZT: search.searchForm.AZZT,
          start: search.searchForm.start,
          limit: search.searchForm.limit,
          status: search.searchForm.status,
        })
          .then(res => {
            table.dataSource = res.data.list;
            pagination.pageTotal = res.data.count;
            search.searchLoading = false;
          })
          .catch(() => {
            search.searchLoading = false;
          });
      },
      goRouter(url, params = {}, tab = 1) {
        router.push({ path: url, query: { hid: params.id, tab: tab } });
      },
    });

    // 弹窗
    let modal = reactive({
      stationPlaceholder: '请选择归属地',
      jurisdictionPlaceholder: '请选择房源属地',
      areaPlaceholder: '请选择区域',
      formTitle: '修改房源信息',
      visibleRoom: false,
      visibleAdd: false,
      visibleJoin: false,
      loading: false,
      isLook: false,
      canSelectStore: true,
      searchList: {}, // 搜索列表
      lockOptions: [],
      selectOptions: [],
      rules: {},
      // 获取查询参数列表
      getSearchList() {
        getSearchList().then(res => {
          modal.searchList = res.data;
        });
      },
      //选择门店
      selectStore(e, option) {
        console.log(option.label);
        modal.addForm.store_id = e.toString();
        modal.addForm.sname = option.label;
      },

      getInitData() {
        return {
          id: '', //,
          pid: '', //平台ID,
          cid: '', // 房东ID,
          store_id: '', //门店ID,
          hid: '', //房源ID,
          FYDJBH: '', //房源登记编号,
          FYTYBM: '', //房源统一编码,
          JYZDJBH: '', //经营者登记编号,
          FYSS1: '', //房源所属省（省市区统一编码）,
          FYSS2: '', //房源所属市（省市区统一编码）,
          FYSSQH: '', //房源所属区（省市区统一编码）,
          FYXXDZ: '', //房源详细地址,
          FYDWJD: '', //房源定位经度,
          FYDWWD: '', //房源定位纬度,
          FYFX: '', //房型/房源名称,
          SFCZ: '', //房源类型0短租1长租,
          SFCZ_text: '', //房源类型0短租1长租,
          RECENTLY_DATE: '', //最近经营日期,
          MSPP: '', //门锁品牌,
          MSPP_text: '', //门锁品牌,
          MSGN: '', //门锁功能,
          MSMAC: '', //门锁设备MAC,
          AZZT: '', //安装状态0未安装1已安装2已拆除,
          AZZT_text: '', //安装状态
          AZSJ: '', //安装时间,
          CCSJ: '', //拆除时间,
          DJSJ: '', //登记时间,
          sname: '',
        };
      },
      // 查看门店
      openDetails(e, type) {
        if (type == 1) {
          modal.isLook = true;
          modal.formTitle = '房源信息';
        } else {
          modal.isLook = false;
          modal.formTitle = '修改房源信息';
        }
        modal.addForm = modal.getInitData();
        modal.visibleAdd = true;
        ChangZhouHouseDetail({
          id: e.id,
        }).then(res => {
          Object.keys(modal.addForm).forEach(i => {
            modal.addForm[i] = res.data[i];
          });
          modal.addForm.id = res.data.id;
          // modal.addForm.status = res.data.status;
          // modal.stationPlaceholder = res.data.cityName;
          // modal.jurisdictionPlaceholder = res.data.jurisdiction_name;
          modal.addForm.SFCZ = res.data.SFCZ.toString();
          modal.addForm.AZZT = res.data.AZZT.toString();
          modal.addForm.MSPP = res.data.MSPP > 0 ? res.data.MSPP.toString() : '9';
          // modal.addForm.room_type = res.data.room_type.toString();
          // modal.addForm.qualification = res.data.qualification.toString();
          // modal.addForm.fwly = res.data.fwly.toString();
          // modal.addForm.flag = res.data.flag.toString();
          // modal.addForm.cqr_zjzl = res.data.cqr_zjzl.toString();
          // modal.addForm.dataFlag = res.data.dataFlag.toString();
          // modal.addForm.djsj_text = res.data.djsj;
          // modal.addForm.store_id =  res.data.store_id > 0 ? res.data.store_id.toString() : '请选择门店';
          modal.addForm.sname = res.data.store_id > 0 ? res.data.sname.toString() : '请选择门店';
          modal.canSelectStore = res.data.store_id > 0 ? true : false;
          modal.lockOptions = res.data.lock_open_type;
          modal.selectOptions = res.data.lock_open_select;
          modal.getSearchList();
        });
      },
      operSyn(e) {
        Modal.confirm({
          title: `是否同步上报数据？`,
          icon: createVNode(ExclamationCircleOutlined),
          centered: true,
          onOk() {
            ChangZhouHouseSyn({
              id: e.id,
            })
              .then(res => {
                message.success(res.msg);
                modal.modalLoading = false;
                table.getTableList();
              })
              .catch(() => {
                modal.modalLoading = false;
              });
          },
        });
      },

      rowData: '',
      addForm: {},
      formRef: '', //表单验证

      modalLoading: false,
      //确定
      confirmFun() {
        console.log(modal.selectOptions);
        if (modal.addForm.id && modal.addForm.id > 0 && modal.isLook === false) {
          modal.handleEditSave();
        } else {
          modal.visibleAdd = false;
        }
      },
      //编辑
      handleEditSave() {
        if (modal.modalLoading) {
          return;
        }
        modal.addForm.MSGN = modal.selectOptions;
        modal.formRef.validate().then(() => {
          modal.modalLoading = true;
          ChangZhouHouseEdit(modal.addForm)
            .then(res => {
              message.success(res.msg);
              modal.visibleAdd = false;
              table.getTableList();
              modal.modalLoading = false;
            })
            .catch(() => {
              modal.modalLoading = false;
            });
        });
      },
      // 选择区域回调
      changeArea(params) {
        if (params) {
          Object.assign(modal.addForm, params);
        }
      },
      // 选择区域回调
      changeStation(params) {
        console.log('city_code');
        modal.addForm.city_code = params.c_code;
        modal.addForm.cityName = params.p_name + '/' + params.c_name;
        modal.addForm.jurisdiction = '';
        modal.addForm.jurisdiction_name = '请选择房源属地';
      },
      // 选择区域回调
      changeJurisdiction(params) {
        modal.addForm.jurisdiction = params.d_code;
        modal.addForm.jurisdiction_name = params.p_name + '/' + params.c_name + '/' + params.a_name + '/' + params.d_name;
      },
    });

    // 分页;
    let pagination = reactive({
      pageTotal: 0,
      pageChange(value) {
        search.searchForm.start = (value - 1) * search.searchForm.limit;
        table.getTableList();
      },
      onShowSizeChange(value) {
        search.searchForm.limit = value;
        table.getTableList();
      },
    });

    watch(
      () => store.state.ContentHeight,
      () => {
        table.tableHeight = countTable(search.topDom) - 80;
      }
    );

    onMounted(() => {
      table.getTableList();
      table.tableHeight = countTable(search.topDom) - 80;
    });

    return {
      ...toRefs(search),
      ...toRefs(table),
      ...toRefs(modal),
      ...toRefs(pagination),
      imgCut,
    };
  },
};
</script>

<style lang="scss" scoped>
.image-box {
  position: relative;
  width: 80px;
  margin: 0 8px 8px 0;

  .del-box {
    position: absolute;
    top: 0;
    right: 0;
    width: 20px;
    height: 20px;
    background-color: #00000044;
    border-radius: 0 0 0 50%;
    display: flex;
    align-items: center;
    justify-content: center;

    &::before {
      content: 'X';
      color: #fff;
      cursor: pointer;
    }
  }
}

.row-box {
  border-bottom: 1px solid #f2f2f2;
  margin-bottom: 20px;

  .f-item {
    margin-bottom: 10px !important;
  }
}

:deep(.areaSel) {
  input::-webkit-input-placeholder {
    color: #262626;
  }

  input:-ms-input-placeholder {
    // IE 10 +
    color: #262626;
  }

  input:-moz-placeholder {
    // Firefox 4 -18
    color: #262626;
  }

  input::-moz-placeholder {
    // Firefox 19 +
    color: #262626;
  }
}
</style>
